import { i18n } from '@/lang/i18n';
import Vue from 'vue';
import {
  environmentService,
  postRequestHandler,
  getRequestHandler
} from "@/utils/services";

const DefaultState = () => {
    return {
      apiUrl: null,
      searchPolicyValues: {
        roomtypeId: null,
        currencyId: null,
        children: null,
        ages: [],
        inventoryIds: [],
        rateplanId: null,
        rates: {
          inventoryId: null,
          sale_value_with_tax: null,
        },
      },
      policyListValues: [],
      policyValues: {},
      policyError: {},
      policiesNotFound: false,
      isLoading: false,
      ChildPolicies: [],
      childspoliciestypes: [],
      hotelId: null,
      gridUpdate: false,
    };
  },
  state = DefaultState(),
  getters = {
    hotelId: state => state.hotelId,
    ChildPolicies: state => state.ChildPolicies,
    childspoliciestypes: state => state.childspoliciestypes,
    searchPolicyValues: state => state.searchPolicyValues,
    policyListValues: state => state.policyListValues,
    policyValues: state => state.policyValues,
    policyError: state => state.policyError,
    policiesNotFound: state => state.policiesNotFound,
    isLoading: state => state.isLoading,
    gridUpdate: state => state.gridUpdate
  },
  mutations = {
    addNewRoom(state, payload) {
      const room = {
        room: payload.roomselected.id,
        rooms: [],
        policies: [],
        rate: {
          total: null,
          roomId: null,
          values: []
        }
      };
      Vue.set(state.ChildPolicies, state.ChildPolicies.length, room);
    },
    addRateDetails(state, payload) {
      let details = {
        roomtypeId: payload.room.roomtype_id,
        rateboxid: payload.room.boxrateselected,
        currencyId: payload.room.currency,
        adults: payload.room.adultstotal,
        children: payload.room.childrenstotal,
        ages: payload.room.agestotal,
        rateplanId: payload.room.rpid.rpid,
        inventoryIds: [],
        rates: []
      };

      details.inventoryIds = payload.room.details.map(detail => {
        return detail.detail.inventory_id;
      });

      details.rates = payload.room.details.map(detail => {
        return {
          inventoryId: detail.detail.inventory_id,
          sale_value_with_tax: detail.detail.total_with_tax,
        }
      });

      const position = state.ChildPolicies.findIndex(chp => chp.room == payload.roomIndex)
      Vue.set(state.ChildPolicies[position].rooms, state.ChildPolicies[position].rooms.length, details);
    },
    setPolicy(state, payload) {
      state.ChildPolicies[payload.roomIndex].rate.roomId = payload.policyData.roomtype_id;
      state.ChildPolicies[payload.roomIndex].rate.values = payload.policyData.inventories.map(inventory => {
        return payload.policyData[inventory]
      });
      state.ChildPolicies[payload.roomIndex].rate.total = state.ChildPolicies[payload.roomIndex].rate.values.map(rate => rate.additionalTotal).reduce((a, b) => a + b, 0);

      Vue.set(state.ChildPolicies[payload.roomIndex].policies, state.ChildPolicies[payload.roomIndex].policies.length, payload.policyData);
    },
    updatePolicyType(state, payload) {
      const index = state.ChildPolicies[payload.roomIndex].policies.findIndex(policy => policy.rateboxid == payload.rateboxid);

      if (index >= 0) {
        const selectedRoom = state.ChildPolicies[payload.roomIndex].policies[index]
        state.ChildPolicies[payload.roomIndex].rate.values = selectedRoom.inventories.map(inventory => {
          return selectedRoom[inventory]
        });
        state.ChildPolicies[payload.roomIndex].rate.total = state.ChildPolicies[payload.roomIndex].rate.values.map(rate => rate.additionalTotal).reduce((a, b) => a + b, 0);
      }
    },
    setChildPolicies(state, payload) {
      state.ChildPolicies = payload;
    },
    setChildpoliciesUrls(state) {
      state.apiUrl = environmentService.apiUrlHotel;
    },
    setPolicyListValues(state, payload) {
      if (payload == 'RESET') {
        state.policyListValues = [];
      } else {
        payload.roomtypeId = state.searchPolicyValues.roomtypeId;
        state.policyListValues.push(payload);
      }
    },
    setGridUpdate(state, payload) {
      state.gridUpdate = payload;
    },
    setHotelId(state, payload) {
      state.hotelId = payload;
    },
    setPolicyValues(state, payload) {
      state.policyValues = payload;
    },
    setPolicyError(state, payload) {
      state.policiesNotFound = true;
      state.policyError = payload;
    },
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    reset_values(state) {
      Object.assign(state.searchPolicyValues, DefaultState().searchPolicyValues);
      state.policyValues = {};
      state.policiesNotFound = false;
    },
    setPolicyTypes(state, payload) {
      state.childspoliciestypes = payload;
      state.childspoliciestypes.push({
        "id": 3,
        "name": "FREE",
        "code": "FR",
        "symbol": "$"
      });
      state.childspoliciestypes = state.childspoliciestypes.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));
    },
    RESET_CHILDPOLICIES(state) {
      Object.assign(state, DefaultState());
    }
  },
  actions = {
    setChildPolicies({
      commit
    }, payload) {
      commit('setChildPolicies', payload);
    },
    setLoading({
      commit
    }, payload) {
      commit('setLoading', payload);
    },
    async getChildsPoliciesTypes({
      commit,
      rootState
    }) {
      const result = await getRequestHandler(`${state.apiUrl}/childpoliciestypes`, {
        headers: rootState.auth.headers
      });
      commit('setPolicyTypes', result);
    },
    setHotelId({
      commit
    }, payload) {
      commit('setHotelId', payload);
    },
    async searchPolicies({
      commit,
      state,
      dispatch,
      rootState
    }) {
      i18n.locale = rootState.global.locale;
      if (!state.apiUrl) {
        commit('setChildpoliciesUrls');
      }

      const result = await postRequestHandler(`${state.apiUrl}/childpolicies`, {
        hotelId: state.hotelId
      }, {
        headers: rootState.auth.headers
      });
      if (result.status == 200) {
        dispatch('inventory/getRoomTypes', {
          hotelIds: [state.hotelId]
        }, {
          root: true
        });
        dispatch('getChildsPoliciesTypes');
        dispatch('setChildPolicies', result.data);
      } else if (result.status == 204) {
        dispatch('inventory/getRoomTypes', {
          hotelIds: [state.hotelId]
        }, {
          root: true
        });
        dispatch('getChildsPoliciesTypes');
        dispatch('setChildPolicies', []);
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text:  i18n.t('lang.store.childpolicies.noPoliciesCreated'),
          type: 'success'
        }, {
          root: true
        });
      } else if (result.status == 404) {
        dispatch('global/setToastNotification', {
          title:  i18n.t('lang.store.childpolicies.childpolicies'),
          text:  i18n.t('lang.store.childpolicies.errorOccured'),
          type: 'danger'
        }, {
          root: true
        });
      }
      commit('setLoading', false);
    },
    setPolicyListValues({
      commit
    }, payload) {
      commit('setPolicyListValues', payload);
    },
    setChildpoliciesUrls({
      commit
    }) {
      commit('setChildpoliciesUrls');
    },
    setGridUpdate({
      commit
    }, payload) {
      commit('setGridUpdate', payload);
    },
    setPolicy({
      commit
    }, payload) {
      commit('setPolicy', payload);
    },
    async setSearchPolicyValues({
      commit,
      dispatch
    }, payload) {
      const roomIndex = state.ChildPolicies.findIndex(room => room.room == payload.roomselected.id);
      if (roomIndex >= 0) {
        const detailIndex = Object.values(state.ChildPolicies[roomIndex].rooms).findIndex(detail => detail.rateboxid == payload.room.boxrateselected);
        if (detailIndex < 0) {
          await commit('addRateDetails', {
            room: payload.room,
            roomIndex
          });
          await dispatch('getPolicyValues', {
            room: roomIndex,
            detail: state.ChildPolicies[roomIndex].rooms.length - 1,
            rateboxid: payload.room.boxrateselected
          });
        } else {
          commit('updatePolicyType', {
            roomIndex,
            rateboxid: payload.room.boxrateselected
          })
        }
      } else {
        await commit('addNewRoom', payload);
        await commit('addRateDetails', {
          room: payload.room,
          roomIndex: payload.roomselected.id
        });
        await dispatch('getPolicyValues', {
          room: state.ChildPolicies.length - 1,
          detail: state.ChildPolicies[state.ChildPolicies.length - 1].rooms.length - 1,
          rateboxid: payload.room.boxrateselected
        });
      }
    },
    async getPolicyValues({
      commit,
      dispatch,
      state,
      rootState
    }, payload) {
      if (!state.apiUrl) {
        commit('setChildpoliciesUrls');
      }
      dispatch('global/setToastNotification', {
        title: i18n.t('lang.store.childpolicies.childpolicies'),
        text: i18n.t('lang.store.childpolicies.retrievingPolicies'),
        type: 'success'
      }, {
        root: true
      });
      const policyValues = state.ChildPolicies[payload.room].rooms[payload.detail];
      let results = await postRequestHandler(`${state.apiUrl}/childpolicies/values`, policyValues, {
        headers: rootState.auth.headers
      });
      if (results.status == 200) {
        let policyData = results.data;
        policyData.roomtype_id = policyValues.roomtypeId;
        policyData.inventories = policyValues.inventoryIds;
        policyData.rateboxid = payload.rateboxid
        commit('setPolicy', {
          roomIndex: payload.room,
          policyData
        });
      } else {
        let errors = "";
        results.errors.forEach(element => {
          errors = errors + "<br>" + element;
        });
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text: errors,
          type: 'danger'
        }, {
          root: true
        });
      }
    },
    async createChildPolicies({
      commit,
      state,
      dispatch,
      rootState
    }, payload) {
      i18n.locale = rootState.global.locale;
      const result = await postRequestHandler(`${state.apiUrl}/childpolicies/create`, payload, {
        headers: rootState.auth.headers
      });
      if (result.status == 201) {
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text: i18n.t('lang.store.childpolicies.createSuccess'),
          type: 'success'
        }, {
          root: true
        });
        commit('setGridUpdate', true);
      } else {
        if (result.status == 404 || result.status == 422) {
          let errors = "";
          result.errors.forEach(element => {
            errors = errors + "<br>" + element;
          });
          dispatch('global/setToastNotification', {
            title: i18n.t('lang.store.childpolicies.childpolicies'),
            text: errors,
            type: 'danger'
          }, {
            root: true
          });
        }
      }
      commit('setLoading', false);
    },
    async editPolicy({
      commit,
      dispatch,
      rootState
    }, payload) {
      i18n.locale = rootState.global.locale;
      commit('setLoading', true);
      const result = await postRequestHandler(`${state.apiUrl}/childpolicies/update`, payload, {
        headers: rootState.auth.headers
      });

      if (result.status == 200) {
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text: i18n.t('lang.store.childpolicies.updateSuccess'),
          type: 'success'
        }, {
          root: true
        });
        dispatch('searchPolicies');
      } else {
        let errors = "";
        result.errors.forEach(element => {
          errors = errors + "<br>" + element;
        });
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text: errors,
          type: 'danger'
        }, {
          root: true
        });
      }
      commit('setLoading', false);
    },
    async removePolicy({
      commit,
      dispatch,
      rootState
    }, payload) {
      i18n.locale = rootState.global.locale;
      const result = await postRequestHandler(`${state.apiUrl}/childpolicies/delete`, payload, {
        headers: rootState.auth.headers
      });
      if (result.status == 200) {
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text: i18n.t('lang.store.childpolicies.deleteSuccess'),
          type: 'success'
        }, {
          root: true
        });
        commit('setLoading', true);
        dispatch('searchPolicies');
      } else {
        let errors = "";
        result.data.errors.forEach(element => {
          errors = errors + "<br>" + element;
        });
        dispatch('global/setToastNotification', {
          title: i18n.t('lang.store.childpolicies.childpolicies'),
          text: errors,
          type: 'danger'
        }, {
          root: true
        });
      }
    },
    resetPolicyValues({
      commit
    }) {
      commit('reset_values');
    },
    RESET_CHILDPOLICIES({
      commit
    }) {
      commit('RESET_CHILDPOLICIES');
    }
  };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/childpolicies.js